/*
|--------------------------------------------------------------------------
| Analytics: Google: Universal
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.analytics.google.universal = {

	/**
	 * Initialize google analytics
	 */
	"init": function(){
		console.log("load Universal Analytics");
		this.loadLibrary();
		this.trackMain();
		this.trackAccounts();
	},


	/**
	 * Load the google analytics library
	 */
	"loadLibrary": function(){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
	},


	/**
	 * Main tracking code for the site.
	 */
	"trackMain": function(){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		var analytics 	= __gh__coreData["3rdPartyData"].analytics.google,
			ua 			= (analytics.ua) ? analytics.ua : null,
			domains 	= (analytics.affiliateDomains) ? analytics.affiliateDomains : null;

		if(!ua){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.analytics.google.universal.trackMain",message:"Missing ua code."});
			return;
		}

		ga('create', ua, 'auto', {'allowLinker': true});
		ga('require', 'linker');
		ga('require', 'displayfeatures');
		ga('linker:autoLink', domains);
		ga('send', 'pageview');
	},

	/**
	 * Main tracking code for additional accounts.
	 */
	"trackAccounts": function(){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		var analytics 			= __gh__coreData["3rdPartyData"].analytics.google,
			accounts 			= (analytics.accounts) 	? analytics.accounts 	: null;
			domains 			= analytics.affiliateDomains,
			blockingValue 		= (typeof(defslot_a) === "undefined") ? "true" : "false";

		if(!accounts){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.analytics.google.universal.trackAccounts",message:"Missing accounts ua code."});
			return;
		}

		for(var key in accounts){
			if(accounts.hasOwnProperty(key)){
			    ga('create', ''+accounts[key]+'', 'auto', {'name': ''+key+'','allowLinker': true});
				ga(''+key+'.require', 'linker');
				ga(''+key+'.require', 'displayfeatures');
				ga(''+key+'.linker:autoLink', domains);
				if(accounts[key] == 'UA-6842750-1'||accounts[key] == 'UA-51861146-1') ga(''+key+'.set', 'dimension1', blockingValue);
				ga(''+key+'.send', 'pageview');
			}
		}
	},

	/**
	 * Track a page element
	 *
	 * @param {object} options
	 * @param {string} options.path - The path portion of a URL. This value should start with a slash (/) character.
	 * @param {string} [options.title=null] - The title of the page (e.g. homepage)
	 */
	"trackElement": function(options){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		this.trackPage(options);
	},

	/**
	 * Track an event
	 *
	 * @param {object} options
	 * @param {string} options.category - object that's interacted with
	 * @param {string} [options.action="click"] - The action event ie. ("click","play","hover","log","etc)
	 * @param {string} [options.label=null] - Useful for categorizing events (e.g. 'Fall Campaign')
	 * @param {number} [options.value=null] - A numeric value associated with the event (e.g. 42)
	 * @param {boolean} [options.nonInteraction=false] - Event is a noninteraction event.
	 * @example <caption>NonInteraction event example.</caption>
	 * __gh__webApp.analytics.google.trackEvent({"path":"/dev-event","action":"log","value": 1,"nonInteraction":true});
	 * @example <caption>Click event example.</caption>
	 * __gh__webApp.analytics.google.trackEvent({"path":"/dev-event"});
	 *
	 */
	"trackEvent": function(options){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		var analytics 		= __gh__coreData["3rdPartyData"].analytics.google,
			accounts 		= (analytics.accounts) ? analytics.accounts : null,
			eventSettings 	= {
			  "hitType"			: 'event',
			  "eventCategory"	: (options.category) ? options.category : null,
			  "eventAction"		: (options.action) ? options.action : "click",
			  "eventLabel"		: (options.label) ? options.label : null,
			  "eventValue"		: (options.value) ? options.value : null,
			},
			fieldsObject = {
				"nonInteraction": (options.nonInteraction) ? true : false,
			};

		if(!options.category){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.analytics.google.universal.trackEvent",message:"Missing category."});
			return;
		}
		ga('send',eventSettings,fieldsObject);

		// accounts
		for(var key in accounts){
			if(accounts.hasOwnProperty(key)){
				ga(''+key+'.send',eventSettings,fieldsObject);
			}
		}
	},

	/**
	 * Track a page view
	 *
	 * @param {object} options
	 * @param {string} options.path - The path portion of a URL. This value should start with a slash (/) character.
	 * @param {string} [options.title=null] - The title of the page (e.g. homepage)
	 */
	"trackPage": function(options){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		var analytics 			= __gh__coreData["3rdPartyData"].analytics.google,
			accounts 			= (analytics.accounts) ? analytics.accounts : null,
			pageViewSettings 	= {
				"title" : (options.title) ? options.title : null,
				"page"	: (options.path) ? options.path : null
			}
		if(!options.path){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.analytics.google.universal.trackPage",message:"Missing path."});
			return;
		}
		ga('send', 'pageview',pageViewSettings);

		// accounts
		for(var key in accounts){
			if(accounts.hasOwnProperty(key)){
				ga(''+key+'.send', 'pageview',pageViewSettings);
			}
		}
	},


	/**
	 * Track a social Interaction
	 *
	 * @param {object} options
	 * @param {string} [options.hitType=social] - The path portion of a URL. This value should start with a slash (/) character.
	 * @param {string} options.socialNetwork - The network on which the action occurs (e.g. Facebook, Twitter)
	 * @param {string} options.socialAction - The type of action that happens (e.g. Like, Send, Tweet)
	 * @param {string} options.socialTarget - Specifies the target of a social interaction. This value is typically a URL but can be any text. (e.g. http://mycoolpage.com)
	 */
	"trackSocial": function(options){

	}
};
